import { Validators } from '@angular/forms';
import {fmcValidator} from '../../../../firstmac-material-lib/projects/fmc-elements/src/lib/common';

export class BorrowerTypeEnhancedModel {
  borrowerType = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ])
  };
  borrowerCount = {
    value: 1,
    validation: Validators.compose([
      Validators.required
    ])
  };
  trustType = {
    value: null,
    validation: Validators.compose([
      // Validators.required
    ])
  };
  trustABN = {
    value: null,
    validationAsync: [fmcValidator('abn')]
  };
  trustABNResult = {
    value: null,
    validation: Validators.compose([
      // Validators.required
    ])
  };
  trustNoABN = {
    value: null,
    validation: Validators.compose([
      // Validators.required
    ])
  };
  companyACN = {
    value: null,
    validationAsync: [fmcValidator('acn')]
  };
  companyACNResult = {
    value: null,
    validation: Validators.compose([
      // Validators.required
    ])
  };
  acnRegistered = {
    value: null,
    validation: Validators.compose([
      // Validators.required
    ])
  };
  /* companyACNConfirmation = {
    value: null,
    validation: Validators.compose([
      // Validators.required
    ])
  }; */
}
